import React from "react";
import { ff, form } from "@mc/mc-legacy";
import { FormErrors, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { Button, Row, Col } from "reactstrap";
import {withLang} from "../../i18n/withLang";
import {i18n} from "../../i18n/i18n";
const FormBody = form.FormBody;

type FormData = {
  code: string;
};

const validate = (formData: FormData, props) => {
  const errors: FormErrors<FormData> = {};

  if (!formData.code) {
    errors.code = i18n(props.lang, "DokladForm_idDoklad_required");
  }

  return errors;
};

class AktivaceUctuForm extends React.Component<any> {
  static formName = "aktivaceUctuForm";

  render() {
    const { submitting, handleSubmit } = this.props;
    return (
      <form.Form onSubmit={handleSubmit} horizontal>
        <p>{i18n(this.props.lang, "ProfilePage_ucetAktivaceDesc")}</p>
        <FormBody>
          <Row>
            <Col md={8} xs={12}>
              <ff.String
                autoComplete={"off"}
                label={false}
                name="code"
                placeholder={i18n(this.props.lang, "ProfilePage_ucetAktivaceKod")}
                disabled={submitting}
                required
              />
            </Col>
            <Col md={4} xs={12}>
              <Button disabled={submitting} color="primary">
                  {i18n(this.props.lang, "ProfilePage_ucetAktivaceAktivovat")}
              </Button>
            </Col>
          </Row>
        </FormBody>
      </form.Form>
    );
  }
}

const reduxFormObj = reduxForm({
  form: AktivaceUctuForm.formName,
  validate,
  initialValues: {},
})(AktivaceUctuForm as any);
export default withLang(connect()(reduxFormObj));
